import { Form } from '@procurify/ui'

import { GlobalCommandOrgCategoriesFormContent } from './components/GlobalCommandOrgCategoriesFormContent'
import { useGlobalCommandOrgCategoriesFormFormik } from './hooks/useGlobalCommandOrgCategoriesFormFormik'
import { GlobalCommandOrgCategoriesFormStyled } from './styles/GlobalCommandOrgCategoriesFormStyled'
import {
  type GlobalCommandOrgCategoriesFormSchema,
  type IGlobalCommandOrgCategoriesFormPrimaryCategory,
  type IGlobalCommandOrgCategoriesFormValue,
} from './types'

export interface IGlobalCommandOrgCategoriesFormProps {
  primaryCategories: IGlobalCommandOrgCategoriesFormPrimaryCategory[]
  initialValue?: IGlobalCommandOrgCategoriesFormValue
  disabled?: boolean
  onSubmit: (value: IGlobalCommandOrgCategoriesFormValue) => void
  onCancel: () => void
}

export const GlobalCommandOrgCategoriesForm = ({
  primaryCategories,
  initialValue,
  disabled,
  onSubmit,
  onCancel,
}: IGlobalCommandOrgCategoriesFormProps) => {
  const { initialValues, validationSchema, handleSubmit } =
    useGlobalCommandOrgCategoriesFormFormik({ initialValue, onSubmit })

  return (
    <GlobalCommandOrgCategoriesFormStyled>
      <Form<GlobalCommandOrgCategoriesFormSchema>
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        <GlobalCommandOrgCategoriesFormContent
          primaryCategories={primaryCategories}
          disabled={disabled}
          onCancel={onCancel}
        />
      </Form>
    </GlobalCommandOrgCategoriesFormStyled>
  )
}
